var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "inter-font": _vm.checkB2Bdomain() || _vm.isRegister(),
        b2b: _vm.checkB2Bdomain() && !_vm.isHomepage,
      },
      attrs: { id: "app inter-font" },
    },
    [
      _c("div", {
        staticClass: "background-overlay",
        class: { "non-homepage-overlay": !_vm.isHomepage },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fixed", attrs: { id: "app-header" } },
        [
          _vm.checkB2Bdomain() || _vm.isRegister() || _vm.isForbidden()
            ? _c("b2b-jhi-navbar", {
                ref: "b2bnavbar",
                on: {
                  "adv:change": _vm.changeAdv,
                  "news:change": _vm.changeNews,
                  "quests:change": _vm.changeQuestions,
                  "companies:change": _vm.changeCompanies,
                },
              })
            : _c("jhi-navbar"),
        ],
        1
      ),
      _vm._v(" "),
      _c("notifications", {
        attrs: {
          width: "300px",
          classes: "vue-notification notification-font",
          position: "top center",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-fluid",
          style: {
            paddingTop: _vm.shouldHavePadding
              ? _vm.isMobile
                ? "2.3rem"
                : "9.3rem"
              : "0",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "card jh-card",
              class: { marg: _vm.shouldHavePadding },
            },
            [_c("router-view", { key: _vm.$route.fullPath })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            { attrs: { id: "login-page", "hide-footer": "", lazy: "" } },
            [
              _c(
                "span",
                {
                  attrs: { slot: "modal-title", id: "login-title" },
                  domProps: { textContent: _vm._s(_vm.$t("login.title")) },
                  slot: "modal-title",
                },
                [_vm._v("Sign in")]
              ),
              _vm._v(" "),
              _c("login-form"),
            ],
            1
          ),
          _vm._v(" "),
          _vm.checkB2Bdomain() || _vm.isRegister() || _vm.isForbidden()
            ? _c("b2b-jhi-footer")
            : _c("jhi-footer"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }